import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconStar from '@/assets/icons/heroIcons/Star.svg';
import LogoDXHeroes from '@/assets/logos/dx-heroes.svg';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import { mergeClasses } from '@/utils/style';
export const DXHeroesBubble = () => {
  const $ = _c(11);
  const {
    t
  } = useTranslation("forEshops");
  const isSkLanguage = useIsSelectedLanguage("sk");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-row justify-center gap-0.5"><IconStar className="h-3-5 w-3.5" /><IconStar className="h-3-5 w-3.5" /><IconStar className="h-3-5 w-3.5" /><IconStar className="h-3-5 w-3.5" /><IconStar className="h-3-5 w-3.5" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = isSkLanguage && "text-sm";
  let t2;
  if ($[1] !== t1) {
    t2 = mergeClasses("font-semibold uppercase", t1);
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("integration.bubble");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <p className={t2}>{t3}</p>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LogoDXHeroes />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <div className="bg-pink mx-auto mb-10 flex h-40 w-40 flex-col items-center justify-center gap-2.5 rounded-full text-center text-white lg:absolute lg:top-0 lg:right-0 lg:mb-0 lg:translate-x-2/3 lg:-translate-y-1/3 lg:rotate-12">{t0}{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};